module.exports = __webpack_public_path__ + "static/media/win.ef025a13.mp3";